(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initElements();
      this.initSlider();
      this.attachEvents();
    }

    attachEvents() {
      this.debouncedOnResize = debounce(() => {
        const isMobileDevices = window.matchMedia(
          this.mobileBreakpoint,
        ).matches;

        if (isMobileDevices && this.slider !== null) {
          this.destroySlider();  
        }

        if (!isMobileDevices && this.slider === null) {
          this.initSlider();
        }
      }, 100);

      window.addEventListener('resize', this.debouncedOnResize.bind(this));
    }

    initElements() {
      this.mobileBreakpoint = '(max-width: 768px)';
      this.slider = null;
      this.options = {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        slidesPerView: 4,
        spaceBetween: 12
      };
    }

    initSlider() {
      if (!this.querySelector('[data-slider]') && this.slider !== null) return;

      const isMobileDevices = window.matchMedia(this.mobileBreakpoint).matches;

      if (isMobileDevices) {
        return;
      }

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }

    destroySlider() {
      this.slider.destroy();

      this.slider = null;
    }

    updateSlider() {
      this.slider.update();
    }

    removeSlide(index) {
      this.slider.removeSlide(index);
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
})();
